export default "__VITE_ASSET__BDV8munH__"